import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { getImage } from 'gatsby-plugin-image'
import PracticeTestCard from '../PracticeTestCard'
import styles from './PracticeTest.module.scss'
import { test } from './test'

const PracticeTest = () => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { extension: { regex: "/(jpg)|(png)|(jpeg)/" } }) {
        edges {
          node {
            base
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)

  const imageMap = {}
  data?.allFile?.edges?.forEach((img) => {
    imageMap[img.node.base] = img.node.childImageSharp.gatsbyImageData
  })

  return (
    <div className={styles.main}>
      <div className={`${styles.container} pb-5 `}>
        <div className={`${styles.inner} py-3 px-1`}>
          <h2 className="px-4 pb-4 text-center">
            Free Practice Aptitude Tests
          </h2>
          <div className="row justify-content-center w-100 mx-auto">
            {test.map((i) => {
              const image = getImage(imageMap[i.img])
              return (
                <PracticeTestCard
                  key={i}
                  color={i.color}
                  img={image}
                  count={i.count}
                  title={i.title}
                  redirectUrl="https://www.jobtestprep.co.uk/shl-practice-tests#PRT"
                />
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PracticeTest
